/** @jsx jsx */
import React from 'react';
import { Box, Heading, Text, jsx } from 'theme-ui';
import { RichText } from 'prismic-reactjs';
import styles from './sc-block.style';
// fallback image
import bannerImg from '../../images/ad-banner/1.jpg';
import { FaSprayCan } from "react-icons/fa";
import { Link } from "gatsby";

type Props = {
	bannerImage: string;
	icon: React.ReactNode;
	title: string;
	subTitle: string;
	path: string;
};

const ScBlock: React.FC<Props> = ({
	bannerImage,
	icon,
	title,
	subTitle,
	path,
}) => {
	return (
		<Box
			sx={{
				backgroundImage: `url(${
					bannerImage && bannerImage ? bannerImage : bannerImg
				})`,
				...styles.wrapper,
			}}
		>
				<Box sx={styles.content}>
					<Link to={path}>				
						<Heading as="h1">{icon}</Heading>
						<Heading as="h3">{title}</Heading>
						<Text as="p">{subTitle}</Text>
					</Link>				
				</Box> 
	
		</Box>
	);
};

export default ScBlock;
